<div class="audio-container">
    <button (click)="onAudioClick()">Generate Audio</button>
    <audio [src]="pollyAudio" controls controlsList="noplaybackrate nodownload"></audio>
</div>